import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { ReportConfig, ReportTableData } from "../../components/Reports/types";
import { useAppState } from "../redux";

type ReportSocketOptions = {
    onReportConfigLoaded?: (message: any) => void
    onReportDataLoaded?: (message: any) => void
    onLoadConfigWithData?: (message: any) => void
    enabled?: boolean
}

export const useReportSocket = (reportPk: number, options?: ReportSocketOptions) => {
    const appState = useAppState()
    const { subsite } = appState.session
    const onReportConfigLoaded = options?.onReportConfigLoaded || (() => undefined)
    const onReportDataLoaded = options?.onReportDataLoaded || (() => undefined)
    const onLoadConfigWithData = options?.onLoadConfigWithData || (() => undefined)

    const [socketOpen, setSocketOpen] = useState(false)
    const [reportNotFound, setReportNotFound] = useState(false)
    const [config, setConfig] = useState<ReportConfig | undefined>()
    const [data, setData] = useState<ReportTableData | undefined>()
    const [configWithData, setConfigWithData] = useState<any | undefined>()

    useEffect(() => {
        const socket = io({ path: `/${subsite}/app/socket.io` })
        if (reportPk) {
            setSocketOpen(true)
            socket.emit("/api/report-writer/query/loadConfigWithData", {
                loadContext: {},
                loadReqTimestamp: Date.now(),
                report_pk: Number(reportPk)
            })
            socket.on("/api/report-writer/query/reportConfigLoaded", (message: ReportConfig) => {
                onReportConfigLoaded(message)
                setConfig(message)
            });
            socket.on("/api/report-writer/query/reportDataLoaded", (message: ReportTableData) => {
                onReportDataLoaded(message)
                setData(message)
            });
            socket.on("/api/report-writer/query/loadConfigWithData", (message) => {
                if (!message) {
                    setReportNotFound(true)
                } else {
                    onLoadConfigWithData(message)
                    setConfigWithData(message)
                }
                setSocketOpen(false)
                socket.close()
            });

        }
        return () => {
            socket.close();
        }
    }, [reportPk]);

    return { socketOpen, reportNotFound, config, data, configWithData }
}